// import React from 'react';
// import ReactDOM from 'react-dom/client';

export default function Footer() {
  return <footer >&copy; 2023 affirmAItion All rights reserved</footer>;
}
